/**
 * 移动端商品列表页
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  List,
  PullToRefresh,
  Empty,
  Skeleton,
  InfiniteScroll,
  SearchBar,
  Tag,
  Dialog,
} from 'antd-mobile';
import { adminProductApi } from '../../api/index';
import Toast from 'antd-mobile/es/components/toast';

export default function MobileProductListPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [keyword, setKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');

  useEffect(() => {
    fetchProducts(1);
  }, [searchKeyword]);

  const fetchProducts = async (pageNum, append = false) => {
    try {
      const params = {
        page: pageNum,
        pageSize: 10,
        keyword: searchKeyword || undefined,
      };
      const data = await adminProductApi.list(params);
      const newProducts = data?.items || [];
      if (append) {
        setProducts((prev) => [...prev, ...newProducts]);
      } else {
        setProducts(newProducts);
      }
      setHasMore(newProducts.length >= 10);
      setPage(pageNum);
    } catch (err) {
      Toast.show('获取商品列表失败');
    } finally {
      setLoading(false);
    }
  };

  const loadMore = async () => {
    if (!hasMore) return;
    await fetchProducts(page + 1, true);
  };

  const refreshData = async () => {
    await fetchProducts(1, false);
  };

  const handleSearch = () => {
    setSearchKeyword(keyword);
  };

  const confirmDelete = (id) => {
    Dialog.confirm({
      content: '确定要删除此商品吗？',
      onConfirm: async () => {
        try {
          await adminProductApi.delete(id);
          Toast.show('删除成功');
          fetchProducts(1);
        } catch (err) {
          Toast.show(err?.response?.data?.message || '删除失败');
        }
      },
    });
  };

  if (loading && products.length === 0) {
    return (
      <div style={{ padding: 16 }}>
        <Skeleton.Title rows={3} />
        <Skeleton.Title rows={5} style={{ marginTop: 16 }} />
        <Skeleton.Title rows={5} style={{ marginTop: 16 }} />
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      {/* 搜索栏 */}
      <div style={{ background: '#fff', padding: '8px 12px' }}>
        <SearchBar
          value={keyword}
          onChange={setKeyword}
          onSearch={handleSearch}
          placeholder="搜索商品"
          style={{ '--background': '#f5f5f5' }}
        />
      </div>

      {/* 商品列表 */}
      <PullToRefresh onRefresh={refreshData}>
        {products.length > 0 ? (
          <List>
            {products.map((product) => (
              <List.Item
                key={product.id}
                clickable
                onClick={() => navigate(`/admin/m/products/${product.id}/edit`)}
                style={{
                  background: '#fff',
                  marginBottom: 12,
                  padding: '12px 16px',
                }}
                description={
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
                    <Tag size="small" color={product.status === 'active' ? 'success' : 'default'}>
                      {product.status === 'active' ? '上架中' : '已下架'}
                    </Tag>
                    <span style={{ fontSize: 13, color: '#999' }}>
                      库存：{product.variants?.reduce((sum, v) => sum + (v.inventoryQty || 0), 0) || 0}
                    </span>
                  </div>
                }
                extra={
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: 16, fontWeight: 600, color: '#f5222d' }}>
                      ${Math.min(...(product.variants?.map((v) => v.price || 0) || [0])).toFixed(2)}
                    </div>
                    <div
                      style={{ fontSize: 13, color: '#ff4d4f', marginTop: 4 }}
                      onClick={(e) => {
                        e.stopPropagation();
                        confirmDelete(product.id);
                      }}
                    >
                      删除
                    </div>
                  </div>
                }
              >
                <div style={{ fontSize: 15, fontWeight: 500, marginBottom: 4 }}>{product.title}</div>
                <div style={{ fontSize: 13, color: '#999', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {product.description?.slice(0, 30) || '暂无描述'}
                </div>
              </List.Item>
            ))}
          </List>
        ) : (
          <div style={{ padding: '80px 0' }}>
            <Empty description="暂无商品" />
          </div>
        )}
      </PullToRefresh>

      {/* 无限滚动加载 */}
      {products.length > 0 && hasMore && (
        <InfiniteScroll loadMore={loadMore} style={{ paddingBottom: 60 }} />
      )}
    </div>
  );
}
